import script from "./FormPDF.vue?vue&type=script&setup=true&lang=js"
export * from "./FormPDF.vue?vue&type=script&setup=true&lang=js"

import "./FormPDF.vue?vue&type=style&index=0&id=33514e36&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33514e36"]])

export default __exports__